import { ACTION } from "./types";
import { api } from "../../../configs/api";
import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, IconTokens, InputStateToken, } from "@voltmoney/schema";
import SharedPropsService from "../../../SharedPropsService";
import { AssetRepositoryMap, AssetRepositoryType, ConfigTokens, getAppHeader, getPrimaryAssetRepository, } from "../../../configs/config";
import _ from "lodash";
import { VOLT_ERROR_CODE } from "../../../configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ShowNewRTAFetchError, isFromAndroidWebview, isFromTDLPlatform } from "../../../configs/utils";
import { CamsFetchErrorHandle } from "./utils";
let hasChangedInDetails = false;
let hasRedirected = false;
let assetRepository;
export const editPanNumber = async (action, _datastore, { instrumentTrack, navigate, ...props }) => {
    hasChangedInDetails = true;
    instrumentTrack("EDIT_BUTTON_CLICKED_TO_FETCH_FOLIO", { "type": "pan" });
    const user = await SharedPropsService.getUser();
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    await navigate(ROUTE.KYC_PAN_VERIFICATION, {
        applicationId: applicationId,
        panNumber: action.payload,
        targetRoute: action.payload.targetRoute,
    });
};
export const editMobileNumber = async (action, _datastore, { instrumentTrack, navigate, analytics, ...props }) => {
    hasChangedInDetails = true;
    // const isGoBackAllowed = await SharedPropsService.getConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED);
    instrumentTrack("EDIT_BUTTON_CLICKED_TO_FETCH_FOLIO", { "type": "phone" });
    instrumentTrack("EDIT_MOBILE_NUMBER_CLICKED");
    analytics("eligibility_sucess", { "event": "eligibility_sucess" });
    let applicationId = '';
    const user = await SharedPropsService.getUser();
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    navigate(ROUTE.UPDATE_PHONE_NUMBER, {
        applicationId: applicationId,
    });
};
export const goBack = async (action, _datastore, { navigateWithClear, goBack }) => {
    goBack();
};
export const editDetailsModalAction = async (action, _datastore, { setDatastore }) => {
    console.log(" *** editDetailsModalAction ***");
    await SharedPropsService.setIsFetchedErrorShowOnce(false);
    // setDatastore(
    //     ROUTE.MF_FETCH_PORTFOLIO,
    //     'fetchPortfolioModals',
    //     <FetchPortfolioModalProps> {
    //         visible: false
    //     }
    // )
};
export const goBackToManageLimit = async (action, _datastore, { navigateWithClear, goBack }) => {
    navigateWithClear(ROUTE.MANAGE_LIMIT);
};
export const autoTriggerOtp = async (action, _datastore, { analytics, instrumentTrack, ...props }) => {
    const user = await SharedPropsService.getUser();
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    const panNumberX = user.linkedBorrowerAccounts[0].accountHolderPAN;
    const phoneNumber = user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
    const emailId = `${user.linkedBorrowerAccounts[0].accountHolderEmail}`.toLowerCase();
    const isAutoTriggerOtp = await SharedPropsService.getConfig(ConfigTokens.IS_MF_FETCH_AUTO_TRIGGER_OTP);
    const assetRepository = await getPrimaryAssetRepository();
    /*** Auto trigger is globally enabled. mostly this will be disabled,
     * and we are manually enabled it when user tries fetch more assets from UnlockLimit Page ***/
    if (isAutoTriggerOtp) {
        instrumentTrack("GET_PORTFOLIO_SOURCE_UPDATED");
        await SharedPropsService.setConfig(ConfigTokens.IS_MF_FETCH_AUTO_TRIGGER_OTP, false);
        await fetchMyPortfolio({
            routeId: ROUTE.MF_FETCH_PORTFOLIO,
            type: ACTION.FETCH_MY_PORTFOLIO,
            payload: {
                applicationId,
                emailId,
                phoneNumber,
                panNumber: panNumberX,
                assetRepository
            },
        }, {}, { analytics, instrumentTrack, ...props, });
    }
};
export const fetchMyPortfolio = async (action, _datastore, { network, navigateWithClear, setDatastore, navigate, goBack, analytics, instrumentTrack, ...props }) => {
    await setDatastore(ROUTE.MF_FETCH_PORTFOLIO, "fetchCTA", {
        loading: true,
    });
    instrumentTrack("CHECK_LIMIT_PAGE_CTA_CLICKED");
    const standardUtilities = {
        network,
        navigateWithClear,
        setDatastore,
        navigate,
        goBack,
        analytics,
        instrumentTrack,
        ...props
    };
    const canGoBack = await SharedPropsService.getConfig(ConfigTokens.IS_MF_FETCH_BACK_ALLOWED);
    const isRetryAllowed = action?.payload?.isRetryAllowed;
    const user = await SharedPropsService.getUser();
    await analytics("eligibility_sucess", { "event": "eligibility_sucess" });
    if (hasChangedInDetails) {
        action.payload.panNumber = user.linkedBorrowerAccounts[0].accountHolderPAN;
        action.payload.phoneNumber =
            user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
        if (!action.payload.applicationId) {
            if (await AsyncStorage.getItem("application_id") !== null) {
                action.payload.applicationId = await AsyncStorage.getItem("application_id");
            }
            else {
                action.payload.applicationId = user.linkedApplications[0].applicationId;
            }
        }
    }
    if (hasRedirected) {
        assetRepository = AssetRepositoryType[action.payload.assetRepository] === "KARVY" ? AssetRepositoryType.CAMS : AssetRepositoryType.KARVY;
    }
    else {
        assetRepository = AssetRepositoryType[action.payload.assetRepository];
    }
    let response;
    console.log('android testing flag: ', await ShowNewRTAFetchError());
    if (await ShowNewRTAFetchError()) {
        // ----- CAMS / KARVY ERROR MODAL ------ //
        response = await network.post(`${api.mfFetchInitV3}`, {
            ...action.payload,
            assetRepository: assetRepository,
        }, {
            headers: await getAppHeader(),
            handleFromMF: canGoBack ? false : !hasRedirected
        });
        if (response?.status === 200) {
            if (response?.data?.status?.toUpperCase() === 'FAILURE') {
                instrumentTrack('GET_MF_PORTFOLIO_AUTH_USER', {
                    result: false,
                    rta: assetRepository,
                    error_type: response?.data?.stepResponseObject?.error?.header
                });
                await CamsFetchErrorHandle(standardUtilities, {
                    response: response,
                    fetchPortfolioPayload: {
                        ...action.payload,
                        assetRepository: assetRepository,
                    },
                    isRetryAllowed: isRetryAllowed
                });
                await setDatastore(action.routeId, "fetchCTA", {
                    label: "Get my portfolio",
                    type: ButtonTypeTokens.LargeFilled,
                    loading: false,
                });
                return;
            }
        }
        // ----- CAMS / KARVY ERROR MODAL ------ //
    }
    else {
        response = await network.post(api.fetchInitV2, {
            ...action.payload,
            assetRepository: assetRepository,
        }, {
            headers: await getAppHeader(),
            handleFromMF: canGoBack ? false : !hasRedirected
        });
    }
    instrumentTrack('GET_MF_PORTFOLIO_AUTH_USER', {
        result: true,
        rta: assetRepository,
        error_type: ''
    });
    await setDatastore(action.routeId, "fetchCTA", {
        label: "Get my portfolio",
        type: ButtonTypeTokens.LargeFilled,
    });
    if (response?.response?.data?.voltErrorCode === "MF_NO_ACCOUNT_FOUND_MATCHING_DETAILS" && !hasRedirected && !canGoBack) {
        hasRedirected = true;
        await fetchMyPortfolio(action, {}, {
            network,
            navigateWithClear,
            setDatastore,
            navigate,
            goBack,
            analytics,
            instrumentTrack, ...props
        });
        return;
    }
    else if (response?.response?.status === 400 &&
        response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.BAD_REQUEST_INVALID_INPUT) {
        await navigate(ROUTE.ALERT_PAGE, {
            alertProps: {
                type: "DEFAULT",
                iconName: IconTokens.Failed,
                title: "Verification failed!",
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: "Edit details",
                ctaAction: {
                    type: ACTION.CLOSE_POPUP,
                    routeId: ROUTE.ALERT_PAGE,
                    payload: {},
                },
            },
        });
        return;
    }
    else if (response?.response?.status === 500) {
        await navigate(ROUTE.ALERT_PAGE, {
            alertProps: {
                type: "DEFAULT",
                iconName: IconTokens.Failed,
                title: "Something went wrong!",
                subTitle: `${response?.response?.data?.message}`,
                ctaLabel: "Edit details",
                ctaAction: {
                    type: ACTION.CLOSE_POPUP,
                    routeId: ROUTE.ALERT_PAGE,
                    payload: {},
                },
            },
        });
        return;
    }
    user.linkedApplications[0].currentStepId = _.get(response, "response.data.updatedApplicationObj.currentStepId", response.data.updatedApplicationObj.currentStepId);
    await SharedPropsService.setUser(user);
    /*** Reset to default asset repository type if the user has changed the asset repository type from the settings page */
    await setDatastore(ROUTE.OTP_AUTH_CAS, "input", {
        state: InputStateToken.DEFAULT,
        charLimit: AssetRepositoryMap.get(assetRepository).OTP_LENGTH,
    });
    await setDatastore(ROUTE.OTP_AUTH_CAS, "subTitle", {
        label: `${AssetRepositoryMap.get(assetRepository).NAME} depository has sent an OTP to `,
    });
    action.payload.assetRepository = assetRepository;
    hasRedirected = false;
    if (await ShowNewRTAFetchError()) {
        navigate(ROUTE.OTP_AUTH_CAS, {
            assetRepository: action.payload.assetRepository,
            identifier: response.data.stepResponseObject.success.identifier,
            otpChannel: response.data.stepResponseObject.success.otpChannel,
            noOfDigits: response.data.stepResponseObject.success.noOfDigits,
            isRetryAllowed: isRetryAllowed
        });
    }
    else {
        navigate(ROUTE.OTP_AUTH_CAS, {
            assetRepository: action.payload.assetRepository,
            identifier: response.data.stepResponseObject.identifier,
            otpChannel: response.data.stepResponseObject.otpChannel,
            noOfDigits: response.data.stepResponseObject.noOfDigits
        });
    }
};
export const selectSource = async (action, _datastore, { instrumentTrack, navigate, setDatastore, ...props }) => {
    hasRedirected = false;
    console.warn("PAYLOAD RECEIVED FROM THE SCREEN", action.payload);
    const assetRepositoryMap = action?.payload?.assetRepositoryMap;
    const assetRepositories = assetRepositoryMap.map(item => item.assetRepository);
    await instrumentTrack("EDIT_PORTFOLIO_SOURCE_CLICKED", {
        sourcesAvailable: assetRepositories
    });
    await navigate(ROUTE.SELECT_SOURCE, { selectedRepo: action.payload.value, assetRepositoryMap: assetRepositoryMap });
};
//@ts-ignore
export const goHome = async (action, _datastore, { navigate, network }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationId = userContextResponse.data.linkedApplications[0].applicationState;
    await SharedPropsService.setApplicationState(applicationId);
    // for elevate we simply go to dashboard if the elevate flow is true and allowed home is true
    // other just post message to close the activity
    if ((await SharedPropsService.getElevateFlow())) {
        if (await SharedPropsService.getAllowHome()) {
            await navigate(ROUTE.DASHBOARD);
            return;
        }
        else {
            window?.parent?.postMessage("Exit callback", "*");
            if (isFromAndroidWebview() && isFromTDLPlatform()) {
                window.open("closeActivity", "_parent");
            }
            // @ts-ignore
            window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
        }
    }
    // keep the origional code as it is
    else if (await AsyncStorage.getItem("application_id") !== null) {
        await navigate(ROUTE.MANAGE_LIMIT_LANDING);
    }
    else {
        if (applicationId === "COMPLETED") {
            await navigate(ROUTE.DASHBOARD);
        }
        else {
            if (await SharedPropsService.showHome()) {
                const reFetch = false;
                await navigate(ROUTE.BORROWER_LANDING_SCREEN, { reFetch });
            }
            else {
                window?.parent?.postMessage("Exit callback", "*");
                if (isFromAndroidWebview() && isFromTDLPlatform()) {
                    window.open("closeActivity", "_parent");
                }
                // @ts-ignore
                window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
            }
        }
    }
};
export const editDetails = async (action, _datastore, { setDatastore }) => {
    await SharedPropsService.setIsFetchedErrorShowOnce(false);
    setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
        visible: false
    });
};
export const needHelp = async (action, _datastore, { navigate, setDatastore }) => {
    await SharedPropsService.setIsFetchedErrorShowOnce(false);
    await setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
        visible: false
    });
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const modalCloseAction = async (action, _datastore, { navigateWithClear, goBack }) => {
    console.log(" *** modalCloseAction ***");
    await SharedPropsService.setIsFetchedErrorShowOnce(false);
};
